export default "__VITE_ASSET__9ca98284__"